interface Line {
  product: { product_id: string };
  quantity: number;
}

const quantities = (lines: Line[]) => lines.reduce((total, line) => total.set(line.product.product_id, (total.get(line.product.product_id) ?? 0) + line.quantity), new Map<string, number>());

/** Signing in merges the account's last cart into this one; true when that brought in anything the guest did not have. */
export const addedAtLogin = (before: Line[], after: Line[]): boolean => {
  const had = quantities(before);
  return [...quantities(after)].some(([productId, quantity]) => quantity > (had.get(productId) ?? 0));
};
